export default __webpack_public_path__ + "static/media/scoreCharts.a155f6fe.png";